import { api } from "@/lib/api";

export interface ChatMessagePayload {
  id?: string;
  role: "user" | "assistant";
  content: string;
  timestamp: string;
  sources?: Record<string, any>[] | null;
  citations?: Record<string, any>[] | null;
  tool_calls?: string[] | null;
  tool_invocations?: Record<string, any>[] | null;
  content_blocks?: Record<string, any>[] | null;
  recommendations?: string[] | null;
  rating?: Record<string, any> | null;
  metadata?: Record<string, any> | null;
  artifact_id?: string | null;
  artifact_version_id?: string | null;
}

export interface ChatSessionPayload {
  id?: string;
  title: string;
  project_id?: string | null;
}

export interface ChatSessionUpdatePayload {
  title?: string | null;
  project_id?: string | null;
}

export interface ChatSessionImportPayload {
  id: string;
  title: string;
  created_at?: string | null;
  updated_at?: string | null;
  messages: ChatMessagePayload[];
}

export const chatHistoryService = {
  listSessions: async (includeMessages = false) => {
    const response = await api.get("/api/v1/chat/sessions", {
      params: { include_messages: includeMessages },
    });
    return response.data as { sessions: any[] };
  },

  getSession: async (sessionId: string) => {
    const response = await api.get(`/api/v1/chat/sessions/${sessionId}`, {
      params: { include_streaming: true },
    });
    return response.data as any;
  },

  createSession: async (payload: ChatSessionPayload) => {
    const response = await api.post("/api/v1/chat/sessions", payload);
    return response.data as any;
  },

  updateSession: async (sessionId: string, payload: ChatSessionUpdatePayload) => {
    const response = await api.patch(`/api/v1/chat/sessions/${sessionId}`, payload);
    return response.data as any;
  },

  deleteSession: async (sessionId: string) => {
    await api.delete(`/api/v1/chat/sessions/${sessionId}`);
  },

  clearSessionMessages: async (sessionId: string) => {
    await api.delete(`/api/v1/chat/sessions/${sessionId}/messages`);
  },

  addMessage: async (sessionId: string, payload: ChatMessagePayload) => {
    const response = await api.post(`/api/v1/chat/sessions/${sessionId}/messages`, payload);
    return response.data as any;
  },

  updateMessage: async (sessionId: string, messageId: string, payload: Partial<ChatMessagePayload>) => {
    const response = await api.patch(`/api/v1/chat/sessions/${sessionId}/messages/${messageId}`, payload);
    return response.data as any;
  },

  bulkImport: async (payload: { sessions: ChatSessionImportPayload[] }) => {
    const response = await api.post("/api/v1/chat/sessions/bulk-import", payload);
    return response.data as any;
  },
};
